export const NEW_ACCOUNT_IDENTIFIER = 'NEW_ACCOUNT_IDENTIFIER';

export const FORM_NAMES = {
    LOGIN_FORM: 'LOGIN_FORM',
};

export const MOBILE_APP_OPENID_REDIRECT_HOSTNAME = 'app.famly.co';
export const MOBILE_APP_OPENID_REDIRECT_PATHNAME = '/app-trap';

export const SELECTED_ACCOUNT_LOCAL_STORAGE_KEY = 'selectedAccount';
